import { apiClient } from '@core/api/ApiClientFactory';
import type { OperationMode } from './types';

export const operationModeService = {
    async loadOperationModes(): Promise<OperationMode[]> {
        try {
            const response = await apiClient.get('operationModes');
            return response.data;
        } catch (error) {
            console.error('[OperationModeService] Error loading operation modes:', error);
            throw error;
        }
    },

    async saveOperationMode(item: OperationMode): Promise<OperationMode> {
        try {
            if (item?.id) {
                const response = await apiClient.put<OperationMode>(`operationModes/${item.id}`, item);
                return response.data;
            }
            const response = await apiClient.post<OperationMode>('operationModes', (({ id, ...rest }) => rest)(item));
            return response.data;
        } catch (error) {
            console.error('[OperationModeService] Error saving operation mode:', error);
            throw error;
        }
    },

    async deleteOperationMode(id: string) {
        try {
            const response = await apiClient.delete(`operationModes/${id}`);
            return response.data;
        } catch (error) {
            console.error('[OperationModeService] Error deleting operation mode:', error);
            throw error;
        }
    },

    async sendDeviceCommand(
        gatewayId: string,
        moduleId: string,
        deviceType: string,
        deviceId: string,
        command: string,
        value?: string
    ): Promise<void> {
        try {
            const response = await apiClient.post(`/shopAutomation/${gatewayId}/${moduleId}/device-command`, {
                deviceType,
                deviceId,
                command,
                value
            });

            return response.data;
        } catch (error: any) {
            console.error('[MyShop] Error sending reboot command:', error);
            throw error;
        }
    }
};
